import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { catchError, filter, finalize, of, Subject, switchMap, tap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FullPageMaskService } from 'common';
import { DialogService } from '../../../services/dialog.service';
import { MatIconModule } from '@angular/material/icon';
import { ThirdPartiesApiService } from '../../../services/third-parties-api.service';
import { AddThirdPartyFormService } from '../../../services/add-third-party-form.service';
import { SecurityService, IUserDetails } from 'common';

export enum UpdateThirdPartyDialogMode {
  Add,
}

export interface UpdateThirdPartyDialogData {
  mode: UpdateThirdPartyDialogMode;
  word?: string;
}

@Component({
  selector: 'si-add-third-party-dialog',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatButtonModule, CommonModule, MatIconModule],
  templateUrl: './add-third-party-dialog.component.html',
  styleUrl: './add-third-party-dialog.component.scss'
})
export class AddThirdPartyDialogComponent implements OnInit, OnDestroy {
  dialogRef = inject(MatDialogRef<AddThirdPartyDialogComponent>);
  data = inject<UpdateThirdPartyDialogData>(MAT_DIALOG_DATA);
  dialogService = inject(DialogService);
  thirdPartyApiService = inject(ThirdPartiesApiService);
  formService = inject(AddThirdPartyFormService);
  maskService = inject(FullPageMaskService);
  user: IUserDetails;

  private _destroy$ = new Subject<void>();
  constructor(
    private security: SecurityService
  ){}

  wordControl = new FormControl('');

  get form() {
    return this.formService.form;
  }

  get addNewWordMode() {
    return this.data.mode === UpdateThirdPartyDialogMode.Add;
  }

  get word() {
    return this.form.value.word;
  }

  get errorMessage() {
    return this.form.controls.word.getError('response') ?? 'Please provide a word';
  }

  ngOnInit() {
    this.formService.init(this.data.word);
    this.user = this.security.profile.user;

  }

  handleSubmit() {
    if (this.form.invalid) {
      return;
    }

    this.dialogService.openConfirmation().afterClosed().pipe(
      filter(confirmed => confirmed),
      tap(() => this.maskService.showLoading()),
      switchMap(() => {
          const thirdPartyRequest = {
            username: this.user.username,
            organisationName: this.word 
          };
            return this.thirdPartyApiService.addThirdParty$(thirdPartyRequest)
        
      }),
      catchError((error) => {
        return of(error);
      }),
      finalize(() => this.maskService.hideLoading()),
    ).subscribe((error) => {
      if (!error) this.dialogRef.close(this.word);
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
  }
}
